import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import Transition from 'react-transition-group/Transition'
import { connect } from 'react-redux'
import { changeActiveSlide } from '../actions'
import './IntroSlide.css'


class IntroSlide extends Slide {

    constructor(props) {
        super(props)
        this.state = {
            in: false,
            current: 0,
            last: false,
        }
        this.onClick = this.onClick.bind(this)
    }

    componentDidMount() {

        this.setState({
            in: true
        })

        const interval = setInterval(() => {
            
            if(this.state.current === this.props.text.length - 1) {
                clearInterval(interval)
                this.setState({ last: true })
                return
            }

            setTimeout(() => this.setState({
                in: true,
                current: this.state.current + 1
            }), 500)

            this.setState({
                in: false
            })

        }, 2000)
        
    }

    onClick() {
        this.props.changeActiveSlide(1)
    }

    render() { 

        const duration = 300

        const defaultStyles = {
            transition: `opacity ${duration}ms ease-in`
        }
        
        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }


        const nodes = this.props.text
            .filter((text, index) => index === this.state.current)

        return super.render(
            <Transition in={this.state.in} timeout={0}>
            {state => (
                <div className='IntroSlide' style={{...defaultStyles, ...transitionStyles[state]}}>
                    <div className='IntroSlide-Text'>{ nodes }</div> 
                    <Transition in={this.state.last} timeout={0}>
                    {state => (
                        <a className='IntroSlide-Down' href='#' style={{...defaultStyles, ...transitionStyles[state]}} onClick={this.onClick}><i className="fas fa-chevron-down"></i></a>
                    )}
                    </Transition>
                    
                </div>
            )}
            </Transition>
        )
    }
}

IntroSlide.propTypes = {
    text: PropTypes.array.isRequired
}

const mapStateToProps = ({ activeSlide }) => ({ activeSlide })
const mapDispatchToProps = dispatch => ({
    changeActiveSlide: slide => dispatch(changeActiveSlide(slide))
})

export default connect(mapStateToProps, mapDispatchToProps)(IntroSlide);


// WEBPACK FOOTER //
// ./src/components/IntroSlide.js